import React from "react";
import CaraCerdasCard from "src/components/LiterasiKeuangan/CardCaraCerdas";

const CaraCerdas = () => {
  return (
    <div className="DoITCERDAS-wrapper">
      <div className="DoITCERDAS-container">
        <div className="DoITCERDAS-wordings">
          <p className="DoITCERDAS-title">Cara Cerdas</p>
          <p className="DoitCerdas-subtitle">
            Temukan beragam artikel dan video literasi keuangan yang dapat
            membantumu raih yang kamu mau.
          </p>
        </div>
        <CaraCerdasCard />
      </div>
      <style jsx>{`
        .DoITCERDAS-wrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          background-color: var(--color-white-softer);
        }
        .DoITCERDAS-container {
          width: 100%;
          max-width: 960px;
          display: flex;
          flex-direction: column;
          margin: 50px 0px;
        }
        .DoITCERDAS-wordings {
          padding: 16px;
        }
        .DoITCERDAS-title {
          font-size: 49px;
          font-weight: 900;
          margin: 0px;
        }
        .DoitCerdas-subtitle {
          font-weight: 400;
          font-size: 18px;
          margin: 0px;
          color: #666666;
        }
        @media only screen and (max-width: 700px) {
          .DoITCERDAS-title {
            font-size: 24px;
            font-weight: 900;
            margin: 0px;
          }
          .DoitCerdas-subtitle {
            font-weight: 400;
            font-size: 16px;
            margin: 0px;
          }
        }
      `}</style>
    </div>
  );
};

export default CaraCerdas;
